(function($) {
  var custEl = customElements;
  if (!custEl.get('cdz-wishlist-sec')) {
    custEl.define('cdz-wishlist-sec', class CdzGrid extends HTMLElement {
      constructor() {
        super();
        var urlParts = document.URL.split('?'), newPrs = this.changeParams(urlParts[1]);
        history.pushState({ newPrs }, '', `${window.location.pathname}${newPrs && '?'.concat(newPrs)}`);
        this.id = this.dataset.section;
        this.max = codazon.wl_max_items;
        this.element = $(this);
        if (!$('body').hasClass('page-wishlist')) if (!$(this).attr('loaded')) this.loadPage(); else this.modify();
      }
      loadPage() {
        this.setAttribute('loaded', '1');
        $('body').addClass('page-wishlist');
        $('head title').text($('[role=page_title]').text());
        if (gbCdzWishlist && gbCdzWishlist.length) {
          var q = 'id:' + gbCdzWishlist.filter((v, i) => { return i < this.max}).join(' OR id:'), id = this.id;
          $.ajax({
            url: document.URL,
            data: {q: q, section_id: id, type: 'product'},
            type: 'get',
            async: true,
            success: (rs) => {
              let $sec = $(`#shopify-section-${id}`), $temp = $sec.find('[role=section_content]');
              $(rs).find('[role=section_content]').insertAfter($temp);
              $temp.remove();
              this.element.find('[role=loader]').addClass('hidden');
              cdzCore.optimizeAssets();
              $sec.hide().fadeIn(500, 'swing', () => {
                $(this).css('display', '');
              }).find('cdz-add-wishlist.active').addClass('cdz-remove').attr('title', 'Remove from wishlist');
              $('body').trigger('contentUpdated');
              this.modify();
            }
          });
        } else {
          this.element.find('[role="empty-msg"]').removeClass('hidden');
          this.element.find('[role=loader]').addClass('hidden');
        }
        $(window).on('cdz_list_item_removed', () => {
          if (!gbCdzCompare.length) {
            this.element.find('[role="empty-msg"]').removeClass('hidden');
            this.element.find('[role=loader]').addClass('hidden');
          }
        });
      }
      modify() {
        setTimeout(() => {
          if (!FacetFiltersForm) return;
          if (FacetFiltersForm.updateURLHash && !FacetFiltersForm.oldUpdateURLHash) {
            FacetFiltersForm.oldUpdateURLHash = FacetFiltersForm.updateURLHash;
            FacetFiltersForm.updateURLHash = (searchParams) => {
              FacetFiltersForm.oldUpdateURLHash(this.changeParams(searchParams));
            };
          }
          let sec = `#shopify-section-${this.id}`, $sec = $(sec);
          $(window).on('cdzLoadmoreBefore', (e, ajax, loadmore) => {
            let pr = new URLSearchParams(ajax.url.split('?')[1]), page = pr.get('page');
            loadmore.historyUrl = Shopify.routes.root + 'search?view=wishlist';
            var q = 'id:' + gbCdzWishlist.filter((v, i) => { return i < this.max}).join(' OR id:');
            ajax.url = Shopify.routes.root + `search?view=wishlist&q=${q}&section_id=${this.id}&type=product`;
            if (page && (page != '1')) {
              loadmore.historyUrl += '&page=' + page;
              ajax.url += '&page=' + page;
            }
          }).on('cdzLoadmoreAfter', () => {
            $('cdz-add-wishlist.active', $sec).addClass('cdz-remove').attr('title', 'Remove from wishlist');
          });
        }, 2000);
      }
      changeParams(searchParams) {
        let prs = searchParams.split('&'), newPrs = [];
        $.each(prs, (i, pr) => {
          let prArr = pr.trim().split('=');
          if (prArr[0] != 'q' && prArr[0] != 'type' && prArr[1]) newPrs.push(pr);
        });
        if (searchParams.search('view=') == -1) {
          newPrs.push('view=wishlist');
        }
        return newPrs.join('&');
      }
    });
  }
})(jQuery);